import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Divider,
  HStack,
} from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

type Props = {
  title: string;
  subtitle?: string;
  onDelete: () => void;
  onClose: () => void;
  leastDestructiveRef: AlertDialogProps['leastDestructiveRef'];
} & Omit<AlertDialogProps, 'onClose' | 'children' | 'leastDestructiveRef'>;

export function DeleteConfirmModal({
  title,
  subtitle,
  onDelete,
  onClose,
  ...props
}: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');

  return (
    <AlertDialog onClose={onClose} {...props}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="500">
            {title}
          </AlertDialogHeader>
          {subtitle && <AlertDialogBody>{subtitle}</AlertDialogBody>}
          <Divider />
          <AlertDialogFooter as={HStack} spacing="4">
            <Button variant="secondary" onClick={onClose}>
              {i18nGeneral('Cancel')}
            </Button>
            <Button variant="delete" onClick={onDelete}>
              {i18nGeneral('Delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}

export type DeleteConfirmModal = Props;
